<template>
  <div class="qyxxgl">
    <div class="u-text-center">
      <car-form
        @submit="submit"
        :showformitem="['coName', 'coEin']"
      >
      <template>
        <el-button type="success" size="small" @click="add">添加</el-button>
      </template>
      </car-form>
    </div>
    <div class=" u-h-100">

      <hy-data-table
        v-model="loading"
        height="94%"
        ref="dataTable"
        @find-page="findPage"
        @detail-handle="detailHandle"
        @qrcode-handle="qrcodeHandle"
        @del="del"
        is-all-handle
        :data="dataTable.list"
        :columns="dataTable.columns"
        :extend-buttons="dataTable.buttons"
        :show-operation="true"
        size="medium"
        :paging="dataTable.paging"
        :extend-but-widht="130"
      ></hy-data-table>
    </div>

    <el-dialog :title="qrcodeType" :visible.sync="dialogVisible"  width="500px"
      :close-on-click-modal="false">
      <el-form :model="form" >
        <el-form-item :label="coName" >
          <el-button type="primary" icon="el-icon-download" size="small" @click="download">下载图片</el-button>
          <img :src="qrcode" width="100%" alt="" height="550px" download>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import carForm from '@/components/form/carForm.vue';
import hyDataTable from '@/components/HyDataTable.vue';
import { mapState } from 'vuex';

export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    return {
      lsqrcode:"1",
      qrcode:"",
      qrcodeType:"",
      coName:"",
      dialogVisible:false,
      saveAddTemplate: {},
      apiUrl: {
        imgUploadApi: this.$apis.POST_hyEnterpriseUploadImg,
        delApi: 'GET_hyEnterpriseDelete',
        addApi: 'POST_hyEnterpriseAdd',
        detailApi: 'GET_hyEnterpriseFind',
        updateApi: 'POST_hyEnterpriseUpdate',
        approvalApi: 'POST_hyEnterpriseVerifyEnterprise',
        indexApi: 'POST_hyEnterpriseIndex',
        qrcode: 'GET_generateQrCode'
      },
      sortName: [
        '企业税号',
        '创建时间',
        '企业名称',
        '联系电话',
        '企业法人',
        '企业执照',
        '身份证号',
        '企业类型',
        '法人身份证正面',
        '法人身份证反面',
        '法人营业执照',
        '经营范围',
        '注册时间',
        '企业状态',
        '入场时间',
        '企业位置',
        //'审批意见'
      ],
      form: {},
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
        },
        columns: [
          { prop: 'coEin', label: '企业税号', minWidth: 120 },
          { prop: 'coName', label: '企业名称', minWidth: 80 },
          { prop: 'coPerson', label: '企业法人', minWidth: 50 },
          { prop: 'coAddress', label: '企业位置', minWidth: 150 },
          { prop: 'coType', label: '企业类型', minWidth: 60 },
          { prop: 'coBusiness', label: '经营范围', minWidth: 80 },
          //{ prop: 'checkStatus', label: '审批状态', minWidth: 60 },
          { prop: 'coCreateTime', label: '注册时间', minWidth: 120 },
          { prop: 'coInTime', label: '入场时间', minWidth: 120 }
        ],
        buttons: [
          {
            label: 'qrcode',
            click: 'qrcode-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'success',
            disabled:false
          },
          {
            label: '详情',
            click: 'detail-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'primary'
          },
          {
            label: '删除',
            click: 'del',
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: 'error'
          }
        ],
        paging: {
          pageIndex: 1 // 表格分页信息
        }
      }
    };
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh
    })
  },
  methods: {
    submit(form) {
      this.form = form;
      // this.form = {
      //   checkStatus: form.checkStatus,
      //   coEin: form.coEin,
      //   coName: form.coName
      // };
      this.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      console.log('findPage', res1);
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    add() {
      const data = this.saveAddTemplate;
      this.$store.commit('boxDetail', {
        data: data,
        title: '新增',
        api: this.apiUrl.addApi,
        uploadImgApi: this.apiUrl.imgUploadApi,
        sort: this.sortName
      });
    },
    detailHandle(res) {
      const data = res.row;
      this.$http[this.apiUrl.detailApi]({ paramsID: data.id }).then(
        (response) => {
          if (response.data)
            this.$store.commit('boxDetail', {
              data: response.data,
              title: '详情',
              api: this.apiUrl.updateApi,
              //approvalApi: this.apiUrl.approvalApi,
              uploadImgApi: this.apiUrl.imgUploadApi,
              sort: this.sortName
            });
        }
      );
    },
    del(res) {
      console.log(res);
      this.$http[this.apiUrl.delApi]({ paramsID: res.row.id }).then(
        (response) => {
          if ((response.code = '00000')) {
            this.$message.success('删除成功');
            if (this.dataTable.list.data.length === 1)
              this.pageIndex = this.pageIndex - 1;
            this.getData();
          } else {
            this.$message.error('删除失败:' + response.msg);
          }
        }
      );
    },
    qrcodeHandle(res) {
       const data = res.row;
       this.lsqrcode = res.command.command;
       if(this.lsqrcode == 1){
         this.qrcodeType = "临时轿车申报二维码";
       }else if(this.lsqrcode == 2){
         this.qrcodeType = "临时客车申报二维码";
       }else if(this.lsqrcode == 3){
         this.qrcodeType = "临时货车申报二维码";
       }else if(this.lsqrcode == 4){
         this.qrcodeType = "临时危化品申报二维码";
       }else{
         this.qrcodeType = "临时人员申报二维码";
       }
       this.coName = data.coName;
       this.dialogVisible = true;
       var newImg = new Image()
       this.qrcode = '../../../static/img/loading.gif'
       newImg.src = '../../../static/img/loading.gif'
       newImg.onload = () => { // 图片加载成功后把地址给原来的img
        this.qrcode = '/api/dqi-hymanage/hyEnterprise/generateQrCode?coId='+data.id+'&type='+this.lsqrcode;
       }
    },
    download(){
      var fileName =  this.coName + this.qrcodeType + ".jpg";
      this.downloadIamge(this.qrcode, fileName);
    },
    downloadIamge(imgsrc, name) {
                //下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    }); // 创建一个单击事件
                    a.download = name || "photo"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
    },
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http[this.apiUrl.indexApi](this.form)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              const result = this.$myPlug.sortName2cn(response.data[i]);
              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, 'data', arr);
          this.saveAddTemplate = JSON.parse(
            JSON.stringify(this.dataTable.list.data[0])
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  created() {
    this.getData();
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/sbgl/qyxxgl.vue